// extracted by mini-css-extract-plugin
module.exports = {"recommended-lives__title":"style_recommended-lives__title__hSaH4","recommended-lives__list":"style_recommended-lives__list__ElwfN"};